import { useCallback, useEffect, useState } from "react";

// Minimal synthetic beep using Web Audio API
function createBeep(frequency: number, duration: number, type: OscillatorType = "sine") {
	const ctx = new (
		window.AudioContext ||
		(window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext
	)();
	const osc = ctx.createOscillator();
	const gain = ctx.createGain();
	osc.type = type;
	osc.frequency.value = frequency;
	osc.connect(gain);
	gain.connect(ctx.destination);
	osc.start();
	gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
	osc.stop(ctx.currentTime + duration);
}

export function useSound() {
	const [enabled, setEnabled] = useState(() => {
		if (typeof localStorage === "undefined") return false;
		return localStorage.getItem("boring-agent-sound") === "true";
	});

	useEffect(() => {
		localStorage.setItem("boring-agent-sound", String(enabled));
	}, [enabled]);

	const playSend = useCallback(() => {
		if (!enabled) return;
		try {
			createBeep(800, 0.08);
		} catch {
			// Audio not available
		}
	}, [enabled]);

	const playReceive = useCallback(() => {
		if (!enabled) return;
		try {
			createBeep(600, 0.1, "triangle");
			setTimeout(() => createBeep(800, 0.1, "triangle"), 80);
		} catch {
			// Audio not available
		}
	}, [enabled]);

	const playError = useCallback(() => {
		if (!enabled) return;
		try {
			createBeep(200, 0.15, "sawtooth");
		} catch {
			// Audio not available
		}
	}, [enabled]);

	return { enabled, setEnabled, playSend, playReceive, playError };
}
